import "./Services.css";
import { Helmet } from "react-helmet";
const Services = () => {
  return (
    <>
     <Helmet>
        <title>Interior Design Services | Custom Home and Office Design | interior </title>
        <meta
          name="description"
          content="Explore our professional interior design services tailored for homes and offices. We offer custom design solutions that blend aesthetics and functionality."
        />
        <meta name="keywords" content="interior design, custom home design, office design, residential design, commercial interior design" />
        
      </Helmet>
      <div className="services-bg">
        <div className="container">
          <div className="row"></div>
        </div>
      </div>
      {/* container-1 */}
      <div className="container mb-4">
        <div className="row">
          <h1 className="text-center service-text mt-4 mb-4">Our Services</h1>
          <h5 className="about-heading mb-4">
            Bringing Dreams to Life, One Space at a Time
          </h5>
          <div className="col-xl-6">
            <div>
            <img
                src="/images/service1.jpg"
                style={{ width: "100%", height: "550px" }}
                className="img-fluid rounded"

              />
          
            </div>
          </div>
          <div className="col-xl-6">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                   <strong>Concept Development</strong>
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Concept development in interior design is a crucial phase
                    where designers establish the overarching theme, style, and
                    mood of a project. It involves translating the client's
                    needs, preferences, and functional requirements into a
                    cohesive design vision. Designers begin by meeting with the
                    client to understand their goals, tastes, lifestyle, and
                    budget for the project. This initial consultation helps
                    establish the parameters and direction for the design
                    concept.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <strong> Post-Occupancy Evaluation</strong>
                   
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Occupancy services refer to the various services provided by
                    a company to help its clients effectively occupy their new
                    spaces, whether it's a new building, a renovated space, or a
                    leased property. These services can range from site
                    selection and space planning to move management and ongoing
                    facilities managementOverall, occupancy services are
                    designed to provide comprehensive support to clients during
                    the entire process of occupying their new spaces, from site
                    selection to ongoing facilities management. By working with
                    an experienced occupancy services provider, clients can
                    ensure that their new space meets their needs, is
                    functional, and contributes to their overall success.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                   <strong>Project Management</strong> 
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Project management is a critical function for any company,
                    particularly those involved in complex projects or
                    construction work. Project management involves planning,
                    organizing, and executing projects efficiently and
                    effectively, from conception to completionOverall, project
                    management is an essential service for companies involved in
                    complex projects, ensuring that projects are completed on
                    time, within budget, and to the client's satisfaction. By
                    working with an experienced project management company,
                    clients can focus on their core business activities while
                    having confidence that their projects are being managed
                    effectively.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------------container---3 */}
    </>
  );
};
export default Services;
